module.exports = __webpack_public_path__ + "static/rouleur-wine-a0866ed03a27d50c5954125de2d1bfa5.jpg";